<template>
  <div v-if="message.role === 'system'" class="intelligence-status f12">
    <transition name="intelligence-status-text" mode="out-in">
      <span :key="message.content" class="intelligence-status__content">
        <span class="intelligence-status__dot" />
        <span>{{ message.content }}</span>
      </span>
    </transition>
  </div>
  <div v-else class="intelligence-message" :class="`intelligence-message--${message.role}`">
    <div
      v-if="message.role === 'assistant'"
      class="intelligence-message__avatar"
    >
      <img src="/favicon-32x32.png" alt="" aria-hidden="true" />
    </div>
    <div class="intelligence-message__content">
      <div class="intelligence-message__bubble f14 line-height-4">{{ message.content }}</div>
      <time
        class="intelligence-message__time f10"
        :class="{'intelligence-message__time--pending': message.isStreaming}"
        :datetime="message.createdAt"
      >
        {{ formattedTime }}
      </time>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProAppIntelligenceMessage',
  props: {
    message: {
      type: Object,
      required: true,
    },
  },
  computed: {
    formattedTime() {
      const date = new Date(this.message.createdAt)
      return Number.isNaN(date.getTime())
        ? ''
        : date.toLocaleTimeString([], {hour: '2-digit', minute: '2-digit'})
    },
  },
}
</script>

<style lang="scss" scoped>
.intelligence-message {
  display: flex;
  align-items: flex-end;
  gap: 8px;
  max-width: 88%;

  &__avatar {
    width: 28px;
    height: 28px;
    flex: 0 0 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: white;
    box-shadow: 0 3px 4px rgba(133, 133, 133, 0.2);

    img {
      width: 21px;
      height: 21px;
    }
  }

  &__content {
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  &__bubble {
    min-width: 48px;
    min-height: 40px;
    padding: 10px 14px;
    border-radius: 20px 20px 20px 4px;
    color: var(--v-secondary-darken4);
    background: var(--v-secondary-lighten4);
    white-space: pre-line;
    overflow-wrap: anywhere;
  }

  &__time {
    min-height: 10px;
    padding: 0 4px;
    color: var(--v-secondary-darken1);
    opacity: 1;
    transform: translateY(2px);
    transition: opacity 0.3s ease;

    &--pending {
      opacity: 0;
    }
  }

  &--user {
    align-self: flex-end;
    justify-content: flex-end;

    .intelligence-message__content {
      align-items: flex-end;
    }

    .intelligence-message__bubble {
      color: white;
      background: var(--v-primary-base);
      border-radius: 20px 20px 4px 20px;
    }
  }
}

.intelligence-status {
  align-self: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 90%;
  min-height: 38px;
  box-sizing: border-box;
  padding: 5px 10px;
  color: var(--v-secondary-darken1);
  text-align: center;
  animation: intelligence-status-appear 0.25s ease;

  &__content {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 7px;
  }

  &__dot {
    width: 6px;
    height: 6px;
    flex: 0 0 6px;
    border-radius: 50%;
    background: var(--v-primary-lighten1);
  }
}

.intelligence-status-text-enter-active,
.intelligence-status-text-leave-active {
  transition: opacity 0.24s ease;
}

.intelligence-status-text-enter,
.intelligence-status-text-leave-to {
  opacity: 0;
}

@keyframes intelligence-status-appear {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@media (prefers-reduced-motion: reduce) {
  .intelligence-message__time,
  .intelligence-status-text-enter-active,
  .intelligence-status-text-leave-active,
  .intelligence-status {
    animation: none;
    transition: none;
  }
}
</style>
